import { render, staticRenderFns } from "./pins.vue?vue&type=template&id=e05d7132"
import script from "./pins.vue?vue&type=script&lang=js"
export * from "./pins.vue?vue&type=script&lang=js"
import style0 from "./pins.vue?vue&type=style&index=0&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/clients/client/pins.vue
// module id = BR/g
// module chunks = 0